

export const imageService = {
    // Error messages
    uploadFailed: 'Image upload failed',
    generateFailed: 'AI image generation failed',
    editFailed: 'Image editing failed',
    getStatusFailed: 'Failed to get generation status',
    getHistoryFailed: 'Failed to get generation history',
    deleteRecordFailed: 'Failed to delete record',
    downloadFailed: 'Download failed',
    downloadImageFailed: 'Failed to download image',
    
    // Validation messages
    selectImageFile: 'Please select an image file',
    unsupportedFormat: 'Only JPG, PNG, WebP formats are supported',
    fileTooLarge: 'Image size cannot exceed 10MB',
    imageUrlEmpty: 'Image URL cannot be empty',
    
    // Default filename
    defaultFilename: 'generated-image.png'
  };
